import { Component, OnInit, Inject, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { CoreLogService } from "../../services/log.service";
import { RatingViewModel } from "../../shared/models";
import { RatingDialogService } from "./ratingdialog.service";
import { FormControl } from "@angular/forms";
import { ContentType } from "../../shared/contentTypes";
import { IOSHelperService } from "../../services/IOSHelper.service";

@Component({
  selector: "ya-ratingdialog",
  templateUrl: "./ratingDialog.component.html",
  styleUrls: ["./ratingDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingDialogComponent implements OnInit {
  name = new FormControl("");
  private textAreaLimitation = 400;
  public textAreaCounter = 400;
  public showValidationError: boolean = false;
  public ratingViewModel: RatingViewModel;
  public hasRating: boolean = false; // if item has rating rating if disable and user can not modifed it again.

  constructor(public bottomSheetRef: MatBottomSheetRef<RatingDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    // private _ratingService: RatingDialogService,
    private _ratingDialogService: RatingDialogService,
    private _iosHelperService: IOSHelperService) {
    this.ratingViewModel = new RatingViewModel();
  }

  ngOnInit() {
    const me = this;
    // if (this.data.contentType !== ContentType.Feedback) {
    me._ratingDialogService.GetRatingViewModel(this.data.contentType, this.data.contentId)
      .then((rating) => {
        if (rating) {
          me.ratingViewModel = rating;
          me.hasRating = true;
          me.PushChanges();
        } else {
          me.ratingViewModel.content_id = this.data.contentId;
          me.ratingViewModel.content_type = this.data.contentType;
        }
      })
      .catch((error) => {
        me._coreLogService.error("RatingDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", error);
      });
    // }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RatingDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  private saveRatingViewModel(): Promise<any> {
    const me = this;
    if (me.data.contentType === ContentType.Feedback) {
      return me._ratingDialogService.SaveFeedbackRatingViewModel(me.ratingViewModel.message, me.ratingViewModel.rating);
    } else {
      return me.ratingPromiseResponse();
    }
  }

  private ratingPromiseResponse(): Promise<RatingViewModel> {
    const me = this;
    return new Promise<RatingViewModel>((resolve, reject) => {
      me._ratingDialogService.SaveRatingViewModel(me.ratingViewModel)
        .then(() => {
          resolve(me.ratingViewModel);
        })
        .catch(reject);
    });
  }

  public limitText(textValue): void {
    const me = this;
    if (me.textAreaLimitation < textValue.length) {
      me.ratingViewModel.message = textValue.substring(0, me.textAreaLimitation);
    } else {
      me.textAreaCounter = me.textAreaLimitation - textValue.length;
    }
    me.PushChanges();
  }

  public showValidationMessage() {
    const me = this;
    me.showValidationError = true;
  }

  public saveRating(): void {
    const me = this;
    me.bottomSheetRef.dismiss(me.saveRatingViewModel());
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

}
